import StartListTable from "../pages/DataTables/StartListTable.js";
import AthleteData from "../pages/DataTables/AthleteData.js";
import Category from "../pages/DataTables/category/Category.js";
import { Navigate, useRoutes } from "react-router-dom";
import MatxLayout from "../pages/maxLayout";
import Advanced from "../pages/DataTables/Advanced.js";
import LoginBoxed from "../pages/Authentication/LoginBoxed.js";
import BlankLayout from "../components/Layouts/BlankLayout.js";
import AddAd from "../pages/Ads/AddAd.js";
import Dashboard from "../pages/Dashboard/Dashboard.js";
import WinnerUser from "../pages/WinnerUser/WinnerUser.js";
import AllUsers from "../pages/AllUsers/AllUsers.js";


function RedirectionWrapper({ to }) {
  const queryString = window.location.search;
  if (queryString) {
    return <Navigate to={`${to}${queryString}`} />;
  }
  return <Navigate to={to} />;
}

function RoleProtectedRoute({ children, allowedRoles }) {
  const userProfile = localStorage.getItem("userProfile");
  const userRole = userProfile ? JSON.parse(userProfile).role : null;
  
  if (!allowedRoles.includes(userRole)) {
    return <Navigate to="/dashboard" />;
  }
  
  return children;
}

const routes = (isLoggedIn) => [
  {
    path: "/",
    element: isLoggedIn ? <MatxLayout /> : <RedirectionWrapper to="/login" />,
    children: [
      {
        index: true,
        element: <RedirectionWrapper to="/dashboard" />,
      },
      {
        path: "/dashboard",
        element: <Dashboard />,
      },
      {
        path: "/event",
        element: (
          <RoleProtectedRoute allowedRoles={['admin']}>
            <Advanced />
          </RoleProtectedRoute>
        ),
      },
      {
        path: "/event/:event_ids",
        element: (
          <RoleProtectedRoute allowedRoles={['admin']}>
            <StartListTable />
          </RoleProtectedRoute>
        ),
      },
      {
        path: "/event/list/athlete/:prog_id",
        element: (
          <RoleProtectedRoute allowedRoles={['admin']}>
            <AthleteData />
          </RoleProtectedRoute>
        ),
      },
      {
        path: "/category",
        element: (
          <RoleProtectedRoute allowedRoles={['admin']}>
            <Category />
          </RoleProtectedRoute>
        ),
      },
      {
        path: "/winner-user",
        element: (
          <RoleProtectedRoute allowedRoles={['admin']}>
            <WinnerUser />
          </RoleProtectedRoute>
        ),
      },
      {
        path: "/all-users",
        element: (
          <RoleProtectedRoute allowedRoles={['admin']}>
            <AllUsers />
          </RoleProtectedRoute>
        ),
      },
      {
        path: "/ads/add",
        element: (
          <RoleProtectedRoute allowedRoles={['admin']}>
            <AddAd />
          </RoleProtectedRoute>
        ),
      },

      // {
      //   path: "/login",
      //   element: <LoginBoxed />,
      //   layout: "blank",
      // },
    ],
  },
  {
    path: "/login",
    element: !isLoggedIn ? <LoginBoxed /> : <RedirectionWrapper to="/dashboard" />,
  },
  { path: "*", element: <BlankLayout /> },
];
export default function Routes(props) {
  const { isLoggedIn } = props;
  return useRoutes(routes(isLoggedIn));
}
